var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffice365Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.945,
    height: 56,
    viewBox: "0 0 46.945 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Office_365-Logo.wine",
    d: "M30.141,49.068c.085-.538.107-39.44.026-40.289L10.33,13.506V40.929L.119,44.917a.6.6,0,0,1-.058-.031c-.015-.011-.034-.027-.036-.042A2.921,2.921,0,0,1,0,44.533Q0,27.913,0,11.318a.985.985,0,0,1,.52-.274Q15.09,5.588,29.665.135A1.5,1.5,0,0,1,30.68.057q8,2.321,16,4.611c.077.023.155.051.265.086v46.7c-1.532.426-3.05.852-4.569,1.27q-5.8,1.6-11.6,3.2a1.656,1.656,0,0,1-1.081-.04q-14.332-5.3-28.67-10.573A1.3,1.3,0,0,1,.488,45l29.653,4.069Z",
    transform: "translate(0 0)",
    fill: "#dc3e15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice365Logo);
export default __webpack_public_path__ + "static/media/office_365_logo.b10df444f2d7bd1aeb8523e0f4f7676e.svg";
export { ForwardRef as ReactComponent };